<template>    
  <v-card> 
    <v-row no-gutters>   
      <v-col
        cols="8" 
        class="text-start pa-2"
      > 
        <h4>{{ mainHeader }}</h4>
        <h6 class="grey--text">
          {{ subHeader }}
        </h6>
      </v-col> 

      <v-col cols="2">
        <v-container
          fluid
          fill-height
        >
          <h4>{{ amount }}</h4>
        </v-container> 
      </v-col> 

      <v-col
        cols="2"
        class="roundColor "
      >
        <v-container
          fluid
          fill-height
          class=" d-flex justify-center"
          @click="click"
        >
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-container> 
      </v-col> 
    </v-row>
  </v-card>    
</template>
<script> 
export default {   
  props : {
    mainHeader : {
      type : String,
      default : ''
    },
    subHeader : {
      type : String,
      default : ''
    },
    amount : {
      type : [Number,String],
      default : '' 
    }
  },
  methods : {
    click () {
      this.$emit('add')
    }
  }
}
</script>
<style scoped>
.roundColor {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px; 
  background-color: var(--bg-secondary-color); 
} 
</style>